import { render, staticRenderFns } from "./CenterMenu.vue?vue&type=template&id=3f021512&scoped=true&"
import script from "./CenterMenu.vue?vue&type=script&lang=js&"
export * from "./CenterMenu.vue?vue&type=script&lang=js&"
import style0 from "./CenterMenu.vue?vue&type=style&index=0&id=3f021512&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f021512",
  null
  
)

export default component.exports